import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, message, Button, Input, Checkbox, Select } from 'antd';
import { isEmpty } from 'utils/utils';
import { getUserDiv } from 'utils/token-utils';
import useStore from 'store';
import { fetcher } from 'services';

export interface UserEditModalProps extends PopupProps {
    id: number;
    username?: string;
    email?: string;
    isCm?: number;
    isPm?: number;
    isOp?: number;
    banned?: number;
    userDiv?: string;
    loginYn: string;
}

const UserEditModal = ({ isOpen, onClose, id, username, email, isCm, isPm, isOp, banned, userDiv, loginYn }: UserEditModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
    const [isFormDone, setIsFormDone] = useState<boolean>(false);
    const [isBanned, setIsBanned] = useState<number>(0);
   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();

  const auth = useStore((state) => state.auth);   
   /* ======================================================
   * events
   * ====================================================== */
    const onCancel = () => {
        onClose?.(false);
    };
        
    const onSubmit = (e) => {
        if (!validateRegistrant())  return;
        
        if (id > 0) {
            onClose?.(true, e.username, e.email, Number(e.isOp), Number(e.isCm), Number(e.isPm), e.newpassword, e.userDiv, Number(e.banned), e.ban_reason);           
        } else {
            fetcher.user.postUserAddCheck ({
                id: 0,
                email: e.email,
            })
            .then((res) => {
                switch (res.code) {
                    case 200:
                        onClose?.(true, e.username, e.email, Number(e.isOp), Number(e.isCm), Number(e.isPm), e.newpassword, e.userDiv);
                    break;
                    default:  
                        message.info(res.message, 1);                    
                    break;
                };
            });              
        }
      };

    const onChangeForm = () => { 
        if (id > 0) {
            setIsFormDone(!(isEmpty(form.getFieldValue('username')) || isEmpty(form.getFieldValue('email'))));
        } else {
            setIsFormDone(!(isEmpty(form.getFieldValue('username')) || isEmpty(form.getFieldValue('email')) || isEmpty(form.getFieldValue('newpassword')) || isEmpty(form.getFieldValue('newpasswordconfirm'))));
        }
    };      
    /* ======================================================
    * methods
    * ====================================================== */
    
    const validateRegistrant = () => {
        if (!isEmpty(form.getFieldValue('newpassword'))) {
            if (!isEmpty(form.getFieldValue('newpasswordconfirm'))) {
                if (form.getFieldValue('newpassword') !== form.getFieldValue('newpasswordconfirm')) {
                    message.error("비밀번호를 다시 확인 부탁 드립니다.", 1);
                    return false;
                }
            } else {
                message.error("비밀번호를 확인을 입력해주세요.", 1);
                return false;
            }
        }
        
        if (form.getFieldValue('banned')) {
            if (isEmpty(form.getFieldValue('ban_reason'))) {
                message.error("영구삭제 사유를 입력해주세요.", 1);
                return false;
            } 
        }
        return true;
    };   

    const validateMessages = {
        required: '',
        types: {
          email: '',
          number: '',
        },
        number: {
          range: '',
        },
      };    
  /* ======================================================
   * effects
   * ====================================================== */

    useEffect(() => {
        form.setFieldsValue({
            username: username || '',
            email: email || '',
            isCm: isCm || false,
            isPm: isPm || false,
            isOp: isOp || false,
            banned: banned || false,   
            ban_reason: '',
            newpassword: '',
            newpasswordconfirm: '',
            userDiv: userDiv?.split(',') ,
        });

    }, []);

    return (
        <ModalWrapper open={isOpen} onCancel={onCancel} width={400} title={id===0?'사용자 등록':'사용자 수정'} closable>
            <Form
                form={form}
                name="UserInfo"
                layout="horizontal"  
                labelCol={{ flex: '80px' }}
                onFieldsChange={onChangeForm}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Form.Item name="username" label={'이름'} rules={[{ required: true, message: '' }]}>
                    <Input type="text" placeholder='이름을 입력하세요'/>                    
                </Form.Item>     
                <Form.Item name="email" label={'이메일'} rules={[{ required: true, type: 'email', message: '' }]}>
                    <Input type="text" placeholder='이메일을 입력하세요' disabled={id>0}/>                    
                </Form.Item>  
                <Form.Item label={'역할'} >
                    <Form.Item
                        name="isCm"
                        valuePropName="checked"
                        style={{ display: 'inline-block', border: 'none' }}
                    >
                        <Checkbox disabled={loginYn === 'N'}>CM</Checkbox>
                    </Form.Item>   
                    <Form.Item
                        name="isPm"
                        valuePropName="checked"
                        style={{ display: 'inline-block' }}
                    >
                        <Checkbox disabled={loginYn === 'N'}>PM</Checkbox>
                    </Form.Item>     
                    <Form.Item
                        name="isOp"
                        valuePropName="checked"
                        style={{ display: 'inline-block' }}
                    >
                        <Checkbox disabled={loginYn === 'N'}>운영자</Checkbox>
                    </Form.Item>                                                                         
                </Form.Item> 
                {(auth?.login?.div?.includes('999')) ? (
                <Form.Item name="userDiv" label={'권한'} rules={[{ required: true, message: '' }]}>
                    <Select 
                        mode="multiple" 
                        allowClear                     
                        options={
                        [
                            {value:"001", label:'업무담당자'},
                            {value:"002", label:'강사'},
                            {value:"101", label:'운영관리자'},
                            {value:"102", label:'재무관리자'},
                            {value:"103", label:'시스템관리자'},
                            {value:"999", label:'마스터'},
                        ]
                    }/>                  
                </Form.Item> 
                ) : (!userDiv?.includes('999')) && (
                <Form.Item name="userDiv" label={'권한'} rules={[{ required: true, message: '' }]}>
                    <Select
                        mode="multiple" 
                        allowClear                           
                        options={
                        [
                            {value:"001", label:'업무담당자'},
                            {value:"002", label:'강사'},
                            {value:"101", label:'운영관리자'},
                            {value:"102", label:'재무관리자'},
                            {value:"103", label:'시스템관리자'},
                        ]
                    }/>                  
                </Form.Item> 
                )}  

                <Form.Item label={id===0?(<label className='ant-form-item-required'>비밀번호</label>):'비밀번호'}>
                    <Form.Item name="newpassword" style={{ display: 'inline-block', width: 'calc(50% - 3px)', marginRight:'6px' }} rules={id===0?[{ required: true, message: '' }]:[]}>
                        <Input type="password" placeholder='비밀번호' />
                    </Form.Item>
                    <Form.Item name="newpasswordconfirm" style={{ display: 'inline-block', width: 'calc(50% - 3px)' }} rules={id===0?[{ required: true, message: '' }]:[]}>
                        <Input type="password" placeholder='비밀번호 확인' />
                    </Form.Item>
                    {(id > 0) && (<label style={{color:'#f00'}}>* 비밀번호 변경을 원할 경우 입력하세요.</label>)}
                </Form.Item>  
                { (id>0) && (
                <Form.Item label={'영구삭제'}>
                    <Form.Item
                        name="banned"
                        valuePropName="checked"
                    >
                        <Checkbox onChange={(e)=>setIsBanned(Number(e.target.checked))}>영구삭제</Checkbox>
                    </Form.Item> 
                    <Form.Item name="ban_reason">
                        <Input type="text" placeholder='영구삭제 사유를 입력하세요' disabled={!isBanned}/>
                    </Form.Item>
                </Form.Item>   
                )} 
                <ButtonGroup className={'buttonsWrapper'}>
                    <Button onClick={onCancel}>취소</Button>
                    <Button htmlType="submit"  type="primary" disabled={!isFormDone}>{id===0?'등록':'수정'}</Button>
                </ButtonGroup>                
            </Form>
        </ModalWrapper>  
    )    
};

export default React.memo(UserEditModal);    